import { FC } from 'react'
import { CourseType } from '../../../types'
import { CourseList } from '..'
import { StyledCourseGroup } from '.'

type Props = {
  label: string
  courses: CourseType[]
  loading?: boolean
}

const CourseGroup: FC<Props> = ({ label, courses, loading }) => {
  if (!courses.length && !loading) {
    return null
  }

  return (
    <StyledCourseGroup>
      <div className="heading">
        <span>{label}</span>
        <div className="count">{courses.length || 0}</div>
      </div>
      <CourseList courses={courses} loading={loading} />
    </StyledCourseGroup>
  )
}

export default CourseGroup
